import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TOP_CONDITION_SETTINGS, canViewAgentNotes } from "./topConditionsConfig";

const useStyles = makeStyles((theme) => ({
  row: { display: "flex", flexWrap: "wrap", columnGap: theme.spacing(2) },
  generalNote: { marginTop: theme.spacing(3) },
  note: { whiteSpace: "pre-wrap", overflowWrap: "anywhere", color: theme.palette.text.primary },
}));

export default function TopConditionsInfo({ settings, role }) {
  const classes = useStyles();
  const showAgentNotes = canViewAgentNotes(role);
  const rates = TOP_CONDITION_SETTINGS.filter(({ type }) => type === "float").flatMap(({ key, infoLabel }) => {
    const value = parseFloat(settings[key]?.value_numeric);
    if (!Number.isFinite(value) || value === 0) return [];
    const formatted = value.toLocaleString("de-AT", { minimumFractionDigits: 2, maximumFractionDigits: 3 });
    return [{ key, text: `${formatted}% ${infoLabel || "variabel (Aufschlag 3m Euribor)"}` }];
  });
  const comment = settings.zins_comment?.value;
  const agentComment = showAgentNotes && settings.zins_agent_comment?.value;
  return <>
    {rates.map(({ key, text }) => (
      <div key={key} className={classes.row}>
        <Typography>{text}</Typography>
        {showAgentNotes && settings[`${key}_agent_note`]?.value && (
          <Typography className={classes.note}>{settings[`${key}_agent_note`].value}</Typography>
        )}
      </div>
    ))}
    {comment && <Typography className={`${classes.note} ${classes.generalNote}`}>{comment}</Typography>}
    {agentComment && <Typography className={`${classes.note} ${classes.generalNote}`}>{agentComment}</Typography>}
    {!rates.length && !comment && !agentComment && <Typography>Keine Top-Konditionen hinterlegt.</Typography>}
  </>;
}
